module.exports = __webpack_public_path__ + "img/p_kt.15a130e6.png";